import { render, staticRenderFns } from "./QuickReactions.vue?vue&type=template&id=58ea3b16&"
import script from "./QuickReactions.vue?vue&type=script&lang=js&"
export * from "./QuickReactions.vue?vue&type=script&lang=js&"
import style0 from "./QuickReactions.vue?vue&type=style&index=0&id=58ea3b16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
